import styled from "styled-components";

const AdminTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 0.75rem 0.85rem;
    text-align: left;
    vertical-align: middle;
  }

  thead th {
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    color: rgba(247, 247, 247, 0.68);
  }

  tbody td {
    border-top:
      1px solid
      rgba(255, 255, 255, 0.08);
  }
`;

export default AdminTable;
